module.exports = __webpack_public_path__ + "img/lemming.60ae12e6.jpg";